<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>
    <div :class="[{ 'p-input-icon-right': iconClass }, divclass]">
      <i :class="iconClass" />
      <InputText
        :type="type"
        :id="id"
        ref="inputField"
        :readonly="readonly"
        :disabled="disabled"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :class="[
          { 'p-invalid': typeof validate !== 'undefined' && validate.$error },
          inputClass,
          'form-control',
        ]"
        v-model="inputValue"
        :min="min"
        :max="max"
        @keydown.enter="$emit('keydown-enter')"
      />
    </div>
    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
      :baseErrorClass="baseErrorClass"
    />
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
export default {
  inheritAttrs: false,
  components: {
    InputText,
  },
  props: {
    autofocus: {
      type: Boolean,
      required: false,
    },
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "text",
      validator: function (value) {
        // The value must match one of these strings
        return ["text", "password", "number"].indexOf(value) !== -1;
      },
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    readonly: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
    },
    inputClass: {
      type: String,
      required: false,
    },
    divclass: {
      type: String,
      default: "",
    },
    min: {
      type: String,
      default: "0",
    },
    max: {
      type: String,
      default: "999999999",
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
    baseErrorClass: {
      type: String,
      required: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
